import React from 'react';
import { S2SafeParsable } from 'libs/end-to-end/src/interfaces';
import { useWriteFn } from 'apps/sigma2-ui/src/lib/hooks/useWriteFn';
import { useWritePattern } from 'apps/sigma2-ui/src/lib/hooks/useWritePattern';

export const useSimpleWritePattern = <TRead, TWrite>({
  getUrlFn,
  method,
  canWrite,
  writeSchema,
  responseSchema,
}: {
  getUrlFn: () => string | null;
  canWrite: boolean;
  writeSchema: S2SafeParsable<unknown, TWrite>;
  responseSchema: S2SafeParsable<unknown, TRead>;
  method?: 'POST' | 'PUT' | 'DELETE';
}) => {
  const { isReadyToWrite, writeFn } = useWriteFn({
    getUrlFn,
    canWrite,
    writeSchema,
    responseSchema,
    method: method ?? 'POST',
  });

  return useWritePattern({
    isReadyToWrite,
    writeFn,
  });
};
